import { render, staticRenderFns } from "./PropChannelPieChart.vue?vue&type=template&id=721a244c&"
import script from "./PropChannelPieChart.vue?vue&type=script&lang=js&"
export * from "./PropChannelPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports